import {AppDispatch} from 'store'
import {listenWindowEvent} from './thunks'
import {online} from './actions'

const removes: (() => void)[] = []

const cleanup = () => removes.forEach((remove) => remove())

export const init = () => (dispatch: AppDispatch) => {
    removes.push(dispatch(listenWindowEvent('online', () => online(true))))
    removes.push(dispatch(listenWindowEvent('offline', () => online(false))))

    return cleanup
}

export const isOnline = () => window.navigator.onLine

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
module?.hot?.dispose(cleanup)
